import io from 'socket.io-client';
import config from '../enviroment/config.json';

var connection = null;

export default {
  Connect() {
    connection = io(config.api[config.current_enviroment]);
  },
  JoinRoom: (payload) => {
    // {id: userid, value: username, roomId: roomId}
    connection.emit('join-room', payload);
  },
  LeaveRoom: (payload) => {
    // {roomId: roomId}
    connection.emit('leave-room', payload);
  },
  Vote: (payload) => {
    connection.emit('vote', payload)
  },
  Ping: (payload) => {
    connection.emit("PING", {dt: new Date(), ...payload});
  },
  GetConnection: () => {
      return connection;
  }
}